import React from 'react';

import { useServerEnrolledStatsigExperiment } from '../../../../../../context/experiments';
import {
    SuggestedCategoriesExperiment,
    SuggestedCategoriesExperimentValues,
} from '../../../../../../types';
import { SuggestedCategoriesContainer } from './SuggestedCategories';

export const SuggestedCategoriesTestContainer = () => {
    const variantType = useGetSuggestedCategoriesExperimentType();
    return variantType ===
        SuggestedCategoriesExperimentValues.control ? null : (
        <SuggestedCategoriesContainer />
    );
};

export const useGetSuggestedCategoriesExperimentType = () => {
    const SuggestedCategoriesExperimentVariant =
        useServerEnrolledStatsigExperiment<SuggestedCategoriesExperimentValues>(
            {
                name: SuggestedCategoriesExperiment.name,
                paramName: SuggestedCategoriesExperiment.paramName,
                defaultValue: SuggestedCategoriesExperiment.values.control,
            },
        ).variant;

    return SuggestedCategoriesExperimentVariant;
};
